module.exports = __webpack_public_path__ + "img/04-mobile.ad69c027.jpg";